import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { DownloadOutlined } from '@ant-design/icons';
import achievementImg from '../../images/achievementBadge.png';
import './achievements.css';
import { downloadAchievement } from './achievementShare';

// The card that gets saved as an image (only this node is captured)
function Certificate({ title, description }) {
  return (
    <div className="ach-cert">
      <span className="ach-cert__brand">LINCFOLIO</span>
      <span className="ach-cert__kicker">ACHIEVEMENT UNLOCKED</span>
      <span className="ach-cert__title">{title}</span>
      <span className="ach-cert__desc">{description}</span>
      <span className="ach-cert__line" />
      <img className="ach-cert__mascot" src={achievementImg} alt="" />
      <span className="ach-cert__site">lincfolio.app</span>
    </div>
  );
}

export default function AchievementModal({ achievement, onClose }) {
  const certRef = useRef(null);

  useEffect(() => {
    if (!achievement) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [achievement, onClose]);

  if (!achievement) return null;

  // Portal to <body> so glass cards (backdrop-filter) can't trap the fixed overlay
  return createPortal(
    <div className="ach-overlay" onClick={onClose}>
      <div className="ach-modal" role="dialog" aria-modal="true" aria-label={achievement.title} onClick={(e) => e.stopPropagation()}>
        <div ref={certRef}>
          <Certificate title={achievement.title} description={achievement.description} />
        </div>

        <button type="button" className="ach-btn ach-btn--gold" onClick={() => downloadAchievement(certRef.current, achievement.title)}>
          <DownloadOutlined /> Download image
        </button>
        <button type="button" className="ach-close" onClick={onClose}>Close</button>
      </div>
    </div>,
    document.body,
  );
}  